import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

/* export interface Sklop {
  value: string;
  viewValue: string;
} */

/* export interface Spremenljivka {
  value: string;
  viewValue: string;
} */

export interface Sezona {
  value: string;
  viewValue: string;
}

export interface Scenarij {
  value: string;
  viewValue: string;
}

/* export interface TempRazmere {
  value: string;
  viewValue: string;
} */

export interface TempKazalniki {
  value: string;
  viewValue: string;
}

export interface PadKazalniki {
  value: string;
  viewValue: string;
}

export interface SPI {
  value: string;
  viewValue: string;
}

export interface SPEI {
  value: string;
  viewValue: string;
}

export interface Pretok {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-filter2',
  templateUrl: './filter2.component.html',
  styleUrls: ['./filter2.component.css']
})
export class Filter2Component implements OnInit {
  name: string;

  selected1 = undefined;
  selected2 = undefined;
  selected3 = undefined;
  selected4 = undefined;
  selected5 = undefined;
  selected7 = undefined;
  selected7a = undefined;
  selected7b = undefined;
  selected7c = undefined;
  selected7d = undefined;
  selected8 = undefined;
  selected9 = undefined;
  selected10 = undefined;

  public izbira = [
    { value: 1, viewValue: 'Temperatura' },
    { value: 2, viewValue: 'Padavine' },
    { value: 3, viewValue: 'Sneg' },
    { value: 4, viewValue: 'Sončno obsevanje' },
    { value: 5, viewValue: 'Veter' },
    { value: 6, viewValue: 'Vodna bilanca' },
    { value: 7, viewValue: 'Hidrološke spremenljivke' },
    { value: 8, viewValue: 'Kazalniki suše' },
    { value: 9, viewValue: 'Raba energije za ogrevanje in hlajenje' },
    { value: 10, viewValue: 'Hidropotencial' }
  ];

  defualtOption = null;
  public spremenljivka = [];
  private sezona1 = [];
  private agroSpremenljivka = [];
  private agroSprVse = [];
  private postaje = [];
  private scenarij1 = [];
  private energSpr = [];


  /* spremenljivka: Spremenljivka[] = [
    {value: 'spr-0', viewValue: 'Povprečna temperatura'},
    {value: 'spr-1', viewValue: 'Najvišja temperatura'},
    {value: 'spr-2', viewValue: 'Najnižja temperatura'},
    {value: 'spr-3', viewValue: 'Temperaturni kazalniki'},
    {value: 'spr-4', viewValue: 'Temperaturne razmere za rast rastlin'},
    {value: 'spr-5', viewValue: 'Višina padavin'},
    {value: 'spr-8', viewValue: 'Padavinski kazalniki'},
    {value: 'spr-9', viewValue: 'Referenčna evapotranspiracija'},
    {value: 'spr-10', viewValue: 'Vodni primanjkljaj'},
    {value: 'spr-11', viewValue: 'Vodni primanjkljaj nad 0 mm'},
    {value: 'spr-14', viewValue: 'Srednji pretoki'},
    {value: 'spr-15', viewValue: 'Veliki pretoki'},
    {value: 'spr-16', viewValue: 'Mali pretoki'}
  ]; */

  sezona: Sezona[] = [
    {value: 'sezona-0', viewValue: 'Leto'},
    {value: 'sezona-1', viewValue: 'Zima'},
    {value: 'sezona-2', viewValue: 'Pomlad'},
    {value: 'sezona-3', viewValue: 'Poletje'},
    {value: 'sezona-4', viewValue: 'Jesen'},
  ];

  scenarij: Scenarij[] = [
    {value: 'scenarij-0', viewValue: 'RCP2.6'},
    {value: 'scenarij-1', viewValue: 'RCP4.5'},
    {value: 'scenarij-2', viewValue: 'RCP8.5'}
  ];

  /* tempRazmere: TempRazmere[] = [
    {value: 'tmpRaz-0', viewValue: 'Povprečna temperatura tal na globini 5 cm (april-junij)'},
    {value: 'tmpRaz-1', viewValue: 'Povprečna temperatura tal na globini 5 cm (julij-september)'},
    {value: 'tmpRaz-2', viewValue: 'Olistanje divjega kostanja'},
    {value: 'tmpRaz-3', viewValue: 'Olistanje bukve'},
    {value: 'tmpRaz-4', viewValue: 'Olistanje lipe'},
    {value: 'tmpRaz-5', viewValue: 'Začetek rastne dobe za temperaturni prag 5 °C'},
    {value: 'tmpRaz-6', viewValue: 'Začetek rastne dobe za temperaturni prag 10 °C'},
    {value: 'tmpRaz-7', viewValue: 'Dolžina rastne dobe za temperaturni prag 5 °C'},
    {value: 'tmpRaz-8', viewValue: 'Dolžina rastne dobe za temperaturni prag 10 °C'},
    {value: 'tmpRaz-9', viewValue: 'Konec rastne dobe za temperaturni prag 5 °C'},
    {value: 'tmpRaz-10', viewValue: 'Konec rastne dobe za temperaturni prag 10 °C'},
    {value: 'tmpRaz-11', viewValue: 'Zadnja spomladanska pozeba (0 °C)'},
    {value: 'tmpRaz-12', viewValue: 'Zadnja spomladanska pozeba (-2 °C)'},
    {value: 'tmpRaz-13', viewValue: 'Prva jesenska pozeba (0 °C)'},
    {value: 'tmpRaz-14', viewValue: 'Prva jesenska pozeba (-2 °C)'},
    {value: 'tmpRaz-15', viewValue: 'Število dni s spomladansko pozebo (0 °C)'},
    {value: 'tmpRaz-16', viewValue: 'Število dni s spomladansko pozebo (-2 °C)'},
    {value: 'tmpRaz-17', viewValue: 'Število dni z jesensko pozebo (0 °C)'},
    {value: 'tmpRaz-18', viewValue: 'Število dni z jesensko pozebo (-2 °C)'},
    {value: 'tmpRaz-19', viewValue: 'Varnostna rezerva pred spomladansko pozebo (0 °C)'},
    {value: 'tmpRaz-20', viewValue: 'Varnostna rezerva pred spomladansko pozebo (-2 °C)'},
    {value: 'tmpRaz-21', viewValue: 'Varnostna rezerva pred jesensko pozebo (0 °C)'},
    {value: 'tmpRaz-22', viewValue: 'Varnostna rezerva pred jesensko pozebo (-2 °C)'}
  ]; */

  tempKazalniki: TempKazalniki[] = [
    {value: 'tmpKaz-0', viewValue: 'Kazalnik vročine pozitiven (EHF)'},
    {value: 'tmpKaz-1', viewValue: 'Število vročinskih valov (po definiciji EHF)'},
    {value: 'tmpKaz-2', viewValue: 'Dolžina vročinskega vala (po definiciji EHF)'},
    {value: 'tmpKaz-3', viewValue: 'Magnituda vročinskega vala (HWMId)'},
    {value: 'tmpKaz-4', viewValue: 'Število vročinskih valov (po definiciji HWMId)'},
    {value: 'tmpKaz-5', viewValue: 'Dolžina vročinskega vala (po definiciji HWMId'},
    {value: 'tmpKaz-6', viewValue: 'Skupna dolžina toplih obdobij (WSDI)'},
    {value: 'tmpKaz-7', viewValue: 'Število toplih dni (SU)'},
    {value: 'tmpKaz-8', viewValue: 'Število vročih dni'},
    {value: 'tmpKaz-9', viewValue: 'Število tropskih noči (TR)'},
    {value: 'tmpKaz-10', viewValue: 'Kazalnik najtoplejših dni (TX90p)'},
    {value: 'tmpKaz-11', viewValue: 'Kazalnik mraza negativen (ECF)'},
    {value: 'tmpKaz-12', viewValue: 'Število obdobij hudega mraza (po definiciji ECF)'},
    {value: 'tmpKaz-13', viewValue: 'Dolžina obdobja hudega mraza (po definiciji ECF)'},
    {value: 'tmpKaz-14', viewValue: 'Skupna dolžina hladnih obdobij (CSDI)'},
    {value: 'tmpKaz-15', viewValue: 'Število hladnih dni (FD)'},
    {value: 'tmpKaz-16', viewValue: 'Število ledenih dni (ID)'},
    {value: 'tmpKaz-17', viewValue: 'Kazalnik najhladnejših dni (TN10p)'}
  ];

  padKazalniki: PadKazalniki[] = [
    {value: 'padKaz-0', viewValue: 'Dolžina najdaljšega suhega obdobja v letu (CDD)'},
    {value: 'padKaz-1', viewValue: 'Dolžina najdaljšega mokrega obdobja v letu (CWD)'},
    {value: 'padKaz-2', viewValue: 'Letna višina padavin iz najbolj mokrih dni (R95pTOT)'},
    {value: 'padKaz-3', viewValue: 'Število dni na leto z več kot 0,1 mm padavin'},
    {value: 'padKaz-4', viewValue: 'Število dni na leto z več kot 1 mm padavin'},
    {value: 'padKaz-5', viewValue: 'Število dni na leto z več kot 10 mm padavin (R10mm)'},
    {value: 'padKaz-6', viewValue: 'Število dni na leto z več kot 20 mm padavin'},
    {value: 'padKaz-7', viewValue: 'Število dni na leto z več kot 50 mm padavin'},
    {value: 'padKaz-8', viewValue: 'Največja dnevna višina padavin (Rx1day)'},
    {value: 'padKaz-9', viewValue: 'Največja petdnevna višina padavin (Rx5day)'}
  ];

  spi: SPI[] = [
    {value: 'spi-0', viewValue: 'SPI-1'},
    {value: 'spi-1', viewValue: 'Pogostost suše (SPI-1)'},
    {value: 'spi-2', viewValue: 'SPI-3'},
    {value: 'spi-3', viewValue: 'Pogostost suše (SPI-3)'},
    {value: 'spi-4', viewValue: 'Trajanje suše (SPI-3)'},
    {value: 'spi-5', viewValue: 'Magnituda suše (SPI-3)'},
    {value: 'spi-6', viewValue: 'SPI-6'},
    {value: 'spi-7', viewValue: 'Pogostost suše (SPI-6)'},
    {value: 'spi-8', viewValue: 'Trajanje suše (SPI-6)'},
    {value: 'spi-9', viewValue: 'Magnituda suše (SPI-6)'}
  ];

  spei: SPEI[] = [
    {value: 'spei-0', viewValue: 'SPEI-1'},
    {value: 'spei-1', viewValue: 'Pogostost suše (SPEI-1)'},
    {value: 'spei-2', viewValue: 'Trajanje suše (SPEI-1)'},
    {value: 'spei-3', viewValue: 'Magnituda suše (SPEI-1)'},
    {value: 'spei-4', viewValue: 'SPEI-3'},
    {value: 'spei-5', viewValue: 'Pogostost suše (SPEI-3)'},
    {value: 'spei-6', viewValue: 'Trajanje suše (SPEI-3)'},
    {value: 'spei-7', viewValue: 'Magnituda suše (SPEI-3)'},
    {value: 'spei-8', viewValue: 'SPEI-6'},
    {value: 'spei-9', viewValue: 'Pogostost suše (SPEI-6)'},
    {value: 'spei-10', viewValue: 'Trajanje suše (SPEI-6)'},
    {value: 'spei-11', viewValue: 'Magnituda suše (SPEI-6)'}
  ];

  pretok: Pretok[] = [
    {value: 'pretok-0', viewValue: 'Pretok pri 0,5 odstotkih časa'},
    {value: 'pretok-1', viewValue: 'Pretok pri 5 odstotkih časa'},
    {value: 'pretok-2', viewValue: 'Pretok pri 10 odstotkih časa'},
    {value: 'pretok-3', viewValue: 'Pretok pri 25 odstotkih časa'},
    {value: 'pretok-4', viewValue: 'Pretok pri 50 odstotkih časa'},
    {value: 'pretok-5', viewValue: 'Pretok pri 75 odstotkih časa'},
    {value: 'pretok-6', viewValue: 'Pretok pri 90 odstotkih časa'},
    {value: 'pretok-7', viewValue: 'Pretok pri 95 odstotkih časa'},
  ];

  selectDisabled3 = true;
  selectDisabled4 = true;
  selectDisabled5 = true;
  selectDisabled7 = true;
  selectDisabled7a = true;
  selectDisabled7b = true;
  selectDisabled7c = true;
  selectDisabled7d = true;
  selectDisabled8 = true;
  selectDisabled9 = true;
  selectDisabled10 = true;
  hidden3 = false;
  hidden4 = false;
  hidden5 = false;
  hidden7 = false;
  hidden7a = false;
  hidden7b = false;
  hidden7c = false;
  hidden7d = false;
  hidden8 = false;
  hidden9 = false;
  hidden10 = false;

  firstDropDownChanged(viewValue: any) {
    const obj = this.izbira[viewValue];
    console.log(obj);
    
    this.selected2 = undefined;
    this.selected3 = undefined;
    this.selected4 = undefined;
    this.selected5 = undefined;
    this.selected7 = undefined;
    this.selected7a = undefined;
    this.selected7b = undefined;
    this.selected7c = undefined;
    this.selected7d = undefined;
    this.selected8 = undefined;
    this.selected9 = undefined;
    this.selected10 = undefined;

    if (!obj) return;
    
    if (obj.value == 1) {
      this.spremenljivka = [
        {value: 'spr-0', viewValue: 'Povprečna temperatura'},
        {value: 'spr-1', viewValue: 'Najvišja temperatura'},
        {value: 'spr-2', viewValue: 'Najnižja temperatura'},
        {value: 'spr-3', viewValue: 'Temperaturni kazalniki'},
        {value: 'spr-4', viewValue: 'Temperaturne razmere za rast rastlin'}
      ];
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled7 = true;
      this.selectDisabled7a = true;
      this.selectDisabled7b = true;
      this.selectDisabled7c = true;
      this.selectDisabled7d = true;
      this.selectDisabled8 = true;
      this.selectDisabled9 = true;
      this.selectDisabled10 = true;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden7 = false;
      this.hidden7a = false;
      this.hidden7b = false;
      this.hidden7c = false;
      this.hidden7d = false;
      this.hidden8 = false;
      this.hidden9 = false;
      this.hidden10 = false;
    }
    
    else if (obj.value == 2) {
      this.spremenljivka = [
        {value: 'spr-5', viewValue: 'Višina padavin'},
        {value: 'spr-8', viewValue: 'Padavinski kazalniki'}
      ];
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled7 = true;
      this.selectDisabled7a = true;
      this.selectDisabled7b = true;
      this.selectDisabled7c = true;
      this.selectDisabled7d = true;
      this.selectDisabled8 = true;
      this.selectDisabled9 = true;
      this.selectDisabled10 = true;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden7 = false;
      this.hidden7a = false;
      this.hidden7b = false;
      this.hidden7c = false;
      this.hidden7d = false;
      this.hidden8 = false;
      this.hidden9 = false;
      this.hidden10 = false;
    }
    else if (obj.value == 3) {
      this.spremenljivka = [
        { value: 'spr-31', viewValue: 'Število dni s snežno odejo' },
        { value: 'spr-32', viewValue: 'Količina vode v novozapadlem snegu' }
      ];
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled7 = true;
      this.selectDisabled7a = true;
      this.selectDisabled7b = true;
      this.selectDisabled7c = true;
      this.selectDisabled7d = true;
      this.selectDisabled8 = true;
      this.selectDisabled9 = true;
      this.selectDisabled10 = true;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden7 = false;
      this.hidden7a = false;
      this.hidden7b = false;
      this.hidden7c = false;
      this.hidden7d = false;
      this.hidden8 = false;
      this.hidden9 = false;
      this.hidden10 = false;
    }
    else if (obj.value == 4) {
      this.spremenljivka = [
        { value: 'spr-41', viewValue: 'Globalni obsev' },
        { value: 'spr-42', viewValue: 'Trajanje sončnega obsevanja' }
      ];
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled7 = true;
      this.selectDisabled7a = true;
      this.selectDisabled7b = true;
      this.selectDisabled7c = true;
      this.selectDisabled7d = true;
      this.selectDisabled8 = true;
      this.selectDisabled9 = true;
      this.selectDisabled10 = true;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden7 = false;
      this.hidden7a = false;
      this.hidden7b = false;
      this.hidden7c = false;
      this.hidden7d = false;
      this.hidden8 = false;
      this.hidden9 = false;
      this.hidden10 = false;
    }
    else if (obj.value == 5) {
      this.spremenljivka = [
        {value: 'spr-51', viewValue: 'Povprečna hitrost vetra'}
      ];
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled7 = true;
      this.selectDisabled7a = true;
      this.selectDisabled7b = true;
      this.selectDisabled7c = true;
      this.selectDisabled7d = true;
      this.selectDisabled8 = true;
      this.selectDisabled9 = true;
      this.selectDisabled10 = true;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden7 = false;
      this.hidden7a = false;
      this.hidden7b = false;
      this.hidden7c = false;
      this.hidden7d = false;
      this.hidden8 = false;
      this.hidden9 = false;
      this.hidden10 = false;
    }
    else if (obj.value == 6) {
      this.spremenljivka = [
        {value: 'spr-9', viewValue: 'Referenčna evapotranspiracija'},
        {value: 'spr-10', viewValue: 'Vodni primanjkljaj'},
        {value: 'spr-11', viewValue: 'Vodni primanjkljaj nad 0 mm'},
        {value: 'spr-61', viewValue: 'Skupni odtok'},
        {value: 'spr-62', viewValue: 'Napajanje podzemnih voda'}
      ];
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled7 = true;
      this.selectDisabled7a = true;
      this.selectDisabled7b = true;
      this.selectDisabled7c = true;
      this.selectDisabled7d = true;
      this.selectDisabled8 = true;
      this.selectDisabled9 = true;
      this.selectDisabled10 = true;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden7 = false;
      this.hidden7a = false;
      this.hidden7b = false;
      this.hidden7c = false;
      this.hidden7d = false;
      this.hidden8 = false;
      this.hidden9 = false;
      this.hidden10 = false;
    }
    else if (obj.value == 7) {
      this.spremenljivka = [
        {value: 'spr-14', viewValue: 'Srednji pretoki'},
        {value: 'spr-15', viewValue: 'Veliki pretoki'},
        {value: 'spr-16', viewValue: 'Mali pretoki'}
      ];
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled7 = true;
      this.selectDisabled7a = true;
      this.selectDisabled7b = true;
      this.selectDisabled7c = true;
      this.selectDisabled7d = true;
      this.selectDisabled8 = true;
      this.selectDisabled9 = true;
      this.selectDisabled10 = true;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden7 = false;
      this.hidden7a = false;
      this.hidden7b = false;
      this.hidden7c = false;
      this.hidden7d = false;
      this.hidden8 = false;
      this.hidden9 = false;
      this.hidden10 = false;
    }
    else if (obj.value == 8) {
      this.spremenljivka = [
        {value: 'spr-81', viewValue: 'SPI'},
        {value: 'spr-82', viewValue: 'SPEI'},
        {value: 'spr-83', viewValue: 'EDDI-1'}
      ];
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled7 = true;
      this.selectDisabled7a = true;
      this.selectDisabled7b = true;
      this.selectDisabled7c = true;
      this.selectDisabled7d = true;
      this.selectDisabled8 = true;
      this.selectDisabled9 = true;
      this.selectDisabled10 = true;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden7 = false;
      this.hidden7a = false;
      this.hidden7b = false;
      this.hidden7c = false;
      this.hidden7d = false;
      this.hidden8 = false;
      this.hidden9 = false;
      this.hidden10 = false;
    }
    else if (obj.value == 9) {
      this.spremenljivka = [
        {value: 'spr-91', viewValue: 'Temperaturni primanjkljaj'},
        {value: 'spr-92', viewValue: 'Temperaturni presežek'},
        {value: 'spr-93', viewValue: 'Kurilna sezona'}
      ];
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled7 = true;
      this.selectDisabled7a = true;
      this.selectDisabled7b = true;
      this.selectDisabled7c = true;
      this.selectDisabled7d = true;
      this.selectDisabled8 = true;
      this.selectDisabled9 = true;
      this.selectDisabled10 = true;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden7 = false;
      this.hidden7a = false;
      this.hidden7b = false;
      this.hidden7c = false;
      this.hidden7d = false;
      this.hidden8 = false;
      this.hidden9 = false;
      this.hidden10 = false;
    }
    else if (obj.value == 10) {
      this.spremenljivka = [
        {value: 'spr-101', viewValue: 'Sprememba trajanja pretoka v %'}
      ];
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled7 = true;
      this.selectDisabled7a = true;
      this.selectDisabled7b = true;
      this.selectDisabled7c = true;
      this.selectDisabled7d = true;
      this.selectDisabled8 = true;
      this.selectDisabled9 = true;
      this.selectDisabled10 = true;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden7 = false;
      this.hidden7a = false;
      this.hidden7b = false;
      this.hidden7c = false;
      this.hidden7d = false;
      this.hidden8 = false;
      this.hidden9 = false;
      this.hidden10 = false;
    }

    this.eventClicked1.emit(this.selected1);
    this.eventClicked2.emit(this.selected2);
    this.eventClicked3.emit(this.selected3);
    this.eventClicked4.emit(this.selected4);
    this.eventClicked5.emit(this.selected5);
    this.eventClicked7.emit(this.selected7);
    this.eventClicked7a.emit(this.selected7a);
    this.eventClicked7b.emit(this.selected7b);
    this.eventClicked7c.emit(this.selected7c);
    this.eventClicked7d.emit(this.selected7d);
    this.eventClicked8.emit(this.selected8);
    this.eventClicked9.emit(this.selected9);
    this.eventClicked10.emit(this.selected10);

  }
  
  secondDropDownChanged(value: any) {
    console.log(value);

    if (value == 'spr-3') {
      this.scenarij1 = [
        {value: 'scenarij-0', viewValue: 'RCP2.6'},
        {value: 'scenarij-1', viewValue: 'RCP4.5'},
        {value: 'scenarij-2', viewValue: 'RCP8.5'}
      ];
      this.selectDisabled3 = false;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled7 = true;
      this.selectDisabled7a = true;
      this.selectDisabled7b = true;
      this.selectDisabled7c = true;
      this.selectDisabled7d = true;
      this.selectDisabled8 = false;
      this.selectDisabled9 = true;
      this.selectDisabled10 = true;
      this.hidden3 = true;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden7 = false;
      this.hidden7a = false;
      this.hidden7b = false;
      this.hidden7c = false;
      this.hidden7d = false;
      this.hidden8 = true;
      this.hidden9 = false;
      this.hidden10 = false;
      this.tempKazalniki = this.tempKazalniki;
      this.selected4 = undefined;
      this.selected5 = undefined;
      this.selected7 = undefined;
      this.selected7a = undefined;
      this.selected7b = undefined;
      this.selected7c = undefined;
      this.selected7d = undefined;
      this.selected9 = undefined;
      this.selected10 = undefined;
    }

    else if (value == 'spr-4') {
      this.scenarij1 = [
        {value: 'scenarij-0', viewValue: 'RCP2.6'},
        {value: 'scenarij-1', viewValue: 'RCP4.5'},
        {value: 'scenarij-2', viewValue: 'RCP8.5'}
      ];
      this.agroSpremenljivka = [
        {value: 'agro-1', viewValue: 'Temperatura tal'},
        {value: 'agro-2', viewValue: 'Fenološke faze'},
        {value: 'agro-3', viewValue: 'Rastna doba'},
        {value: 'agro-4', viewValue: 'Pozeba'},
      ];
      this.selectDisabled3 = true;
      this.selectDisabled4 = false;
      this.selectDisabled5 = true;
      this.selectDisabled7 = true;
      this.selectDisabled7a = true;
      this.selectDisabled7b = true;
      this.selectDisabled7c = true;
      this.selectDisabled7d = true;
      this.selectDisabled8 = true;
      this.selectDisabled9 = true;
      this.selectDisabled10 = true;
      this.hidden3 = false;
      this.hidden4 = true;
      this.hidden5 = false;
      this.hidden7 = false;
      this.hidden7a = false;
      this.hidden7b = false;
      this.hidden7c = false;
      this.hidden7d = false;
      this.hidden8 = false;
      this.hidden9 = false;
      this.hidden10 = false;
      this.selected3 = undefined;
      this.selected7 = undefined;
      this.selected7a = undefined;
      this.selected7b = undefined;
      this.selected7c = undefined;
      this.selected7d = undefined;
      this.selected8 = undefined;
      this.selected9 = undefined;
      this.selected10 = undefined;
    }

    else if (value == 'spr-8') {
      this.scenarij1 = [
        {value: 'scenarij-0', viewValue: 'RCP2.6'},
        {value: 'scenarij-1', viewValue: 'RCP4.5'},
        {value: 'scenarij-2', viewValue: 'RCP8.5'}
      ];
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled7 = false;
      this.selectDisabled7a = true;
      this.selectDisabled7b = true;
      this.selectDisabled7c = true;
      this.selectDisabled7d = true;
      this.selectDisabled8 = false;
      this.selectDisabled9 = true;
      this.selectDisabled10 = true;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden7 = true;
      this.hidden7a = false;
      this.hidden7b = false;
      this.hidden7c = false;
      this.hidden7d = false;
      this.hidden8 = true;
      this.hidden9 = false;
      this.hidden10 = false;
      this.padKazalniki = this.padKazalniki;
      this.selected3 = undefined;
      this.selected4 = undefined;
      this.selected5 = undefined;
      this.selected7a = undefined;
      this.selected7b = undefined;
      this.selected7c = undefined;
      this.selected7d = undefined;
      this.selected9 = undefined;
      this.selected10 = undefined;
    }

    else if (value == 'spr-14' || value == 'spr-15' || value == 'spr-16') {
      this.scenarij1 = [
        {value: 'scenarij-0', viewValue: 'RCP2.6'},
        {value: 'scenarij-1', viewValue: 'RCP4.5'},
        {value: 'scenarij-2', viewValue: 'RCP8.5'}
      ];
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled7 = true;
      this.selectDisabled7a = true;
      this.selectDisabled7b = true;
      this.selectDisabled7c = true;
      this.selectDisabled7d = true;
      this.selectDisabled8 = false;
      this.selectDisabled9 = true;
      this.selectDisabled10 = true;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden7 = false;
      this.hidden7a = false;
      this.hidden7b = false;
      this.hidden7c = false;
      this.hidden7d = false;
      this.hidden8 = true;
      this.hidden9 = false;
      this.hidden10 = false;
      this.selected3 = undefined;
      this.selected4 = undefined;
      this.selected5 = undefined;
      this.selected7 = undefined;
      this.selected7a = undefined;
      this.selected7b = undefined;
      this.selected7c = undefined;
      this.selected7d = undefined;
      this.selected9 = undefined;
      this.selected10 = undefined;
    }

    else if (value == 'spr-11') {
      this.scenarij1 = [
        {value: 'scenarij-0', viewValue: 'RCP2.6'},
        {value: 'scenarij-1', viewValue: 'RCP4.5'},
        {value: 'scenarij-2', viewValue: 'RCP8.5'}
      ];
      this.sezona1 = [
        {value: 'sezona-0', viewValue: 'Leto'},
        {value: 'sezona-3', viewValue: 'Poletje'},
        {value: 'sezona-4', viewValue: 'Jesen'}
      ];
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled7 = true;
      this.selectDisabled7a = true;
      this.selectDisabled7b = true;
      this.selectDisabled7c = true;
      this.selectDisabled7d = true;
      this.selectDisabled8 = false;
      this.selectDisabled9 = false;
      this.selectDisabled10 = true;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden7 = false;
      this.hidden7a = false;
      this.hidden7b = false;
      this.hidden7c = false;
      this.hidden7d = false;
      this.hidden8 = true;
      this.hidden9 = true;
      this.hidden10 = false;
      this.selected3 = undefined;
      this.selected4 = undefined;
      this.selected5 = undefined;
      this.selected7 = undefined;
      this.selected7a = undefined;
      this.selected7b = undefined;
      this.selected7c = undefined;
      this.selected7d = undefined;
      this.selected9 = undefined;
      this.selected10 = undefined;
    }

    else if (value == 'spr-83') {
      this.scenarij1 = [
        {value: 'scenarij-1', viewValue: 'RCP4.5'},
        {value: 'scenarij-2', viewValue: 'RCP8.5'}
      ];
      this.sezona1 = [
        {value: 'sezona-5', viewValue: 'Rastna doba'},
        {value: 'sezona-6', viewValue: 'April-Junij'},
        {value: 'sezona-7', viewValue: 'Julij-September'},
        {value: 'sezona-8', viewValue: 'April'},
        {value: 'sezona-9', viewValue: 'Maj'},
        {value: 'sezona-10', viewValue: 'Junij'},
        {value: 'sezona-11', viewValue: 'Julij'},
        {value: 'sezona-12', viewValue: 'Avgust'},
        {value: 'sezona-13', viewValue: 'September'}
      ];
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled7 = true;
      this.selectDisabled7a = true;
      this.selectDisabled7b = true;
      this.selectDisabled7c = true;
      this.selectDisabled7d = true;
      this.selectDisabled8 = false;
      this.selectDisabled9 = false;
      this.selectDisabled10 = true;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden7 = false;
      this.hidden7a = false;
      this.hidden7b = false;
      this.hidden7c = false;
      this.hidden7d = false;
      this.hidden8 = true;
      this.hidden9 = true;
      this.hidden10 = false;
      this.selected3 = undefined;
      this.selected4 = undefined;
      this.selected5 = undefined;
      this.selected7 = undefined;
      this.selected7a = undefined;
      this.selected7b = undefined;
      this.selected7c = undefined;
      this.selected7d = undefined;
      this.selected8 = undefined;
      this.selected9 = undefined;
      this.selected10 = undefined;
    }

    else if (value == 'spr-81') {
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled7 = true;
      this.selectDisabled7a = false;
      this.selectDisabled7b = true;
      this.selectDisabled7c = true;
      this.selectDisabled7d = true;
      this.selectDisabled8 = false;
      this.selectDisabled9 = true;
      this.selectDisabled10 = true;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden7 = false;
      this.hidden7a = true;
      this.hidden7b = false;
      this.hidden7c = false;
      this.hidden7d = false;
      this.hidden8 = true;
      this.hidden9 = false;
      this.hidden10 = false;
      this.spi = this.spi;
      this.selected3 = undefined;
      this.selected4 = undefined;
      this.selected5 = undefined;
      this.selected7 = undefined;
      this.selected7a = undefined;
      this.selected7b = undefined;
      this.selected7c = undefined;
      this.selected7d = undefined;
      this.selected9 = undefined;
      this.selected10 = undefined;
    }

    else if (value == 'spr-82') {
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled7 = true;
      this.selectDisabled7a = true;
      this.selectDisabled7b = false;
      this.selectDisabled7c = true;
      this.selectDisabled7d = true;
      this.selectDisabled8 = false;
      this.selectDisabled9 = true;
      this.selectDisabled10 = true;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden7 = false;
      this.hidden7a = false;
      this.hidden7b = true;
      this.hidden7c = false;
      this.hidden7d = false;
      this.hidden8 = true;
      this.hidden9 = false;
      this.hidden10 = false;
      this.spei = this.spei;
      this.selected3 = undefined;
      this.selected4 = undefined;
      this.selected5 = undefined;
      this.selected7 = undefined;
      this.selected7a = undefined;
      this.selected7b = undefined;
      this.selected7c = undefined;
      this.selected7d = undefined;
      this.selected9 = undefined;
      this.selected10 = undefined;
    }
    else if (value == 'spr-91') {
      this.scenarij1 = [
        {value: 'scenarij-0', viewValue: 'RCP2.6'},
        {value: 'scenarij-1', viewValue: 'RCP4.5'},
        {value: 'scenarij-2', viewValue: 'RCP8.5'}
      ];
      this.sezona1 = [
        {value: 'sezona-0', viewValue: 'Leto'},
        {value: 'sezona-1', viewValue: 'Zima'},
        {value: 'sezona-2', viewValue: 'Pomlad'},
        {value: 'sezona-3', viewValue: 'Poletje'},
        {value: 'sezona-4', viewValue: 'Jesen'}
      ];
      this.energSpr = [
        {value: 'energSpr-0', viewValue: 'Prag 12 °C'}
      ];
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled7 = true;
      this.selectDisabled7a = true;
      this.selectDisabled7b = true;
      this.selectDisabled7c = false;
      this.selectDisabled7d = true;
      this.selectDisabled8 = false;
      this.selectDisabled9 = false;
      this.selectDisabled10 = true;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden7 = false;
      this.hidden7a = false;
      this.hidden7b = false;
      this.hidden7c = true;
      this.hidden7d = false;
      this.hidden8 = true;
      this.hidden9 = true;
      this.hidden10 = false;
      this.selected3 = undefined;
      this.selected4 = undefined;
      this.selected5 = undefined;
      this.selected7 = undefined;
      this.selected7a = undefined;
      this.selected7b = undefined;
      this.selected7c = undefined;
      this.selected7d = undefined;
      this.selected9 = undefined;
      this.selected10 = undefined;
    }
    else if (value == 'spr-92') {
      this.scenarij1 = [
        {value: 'scenarij-0', viewValue: 'RCP2.6'},
        {value: 'scenarij-1', viewValue: 'RCP4.5'},
        {value: 'scenarij-2', viewValue: 'RCP8.5'}
      ];
      this.sezona1 = [
        {value: 'sezona-0', viewValue: 'Leto'},
        {value: 'sezona-1', viewValue: 'Zima'},
        {value: 'sezona-2', viewValue: 'Pomlad'},
        {value: 'sezona-3', viewValue: 'Poletje'},
        {value: 'sezona-4', viewValue: 'Jesen'}
      ];
      this.energSpr = [
        {value: 'energSpr-1', viewValue: 'Prag 18 °C'},
        {value: 'energSpr-2', viewValue: 'Prag 21 °C'},
        {value: 'energSpr-3', viewValue: 'Prag 23 °C'}
      ];
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled7 = true;
      this.selectDisabled7a = true;
      this.selectDisabled7b = true;
      this.selectDisabled7c = false;
      this.selectDisabled7d = true;
      this.selectDisabled8 = false;
      this.selectDisabled9 = false;
      this.selectDisabled10 = true;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden7 = false;
      this.hidden7a = false;
      this.hidden7b = false;
      this.hidden7c = true;
      this.hidden7d = false;
      this.hidden8 = true;
      this.hidden9 = true;
      this.hidden10 = false;
      this.selected3 = undefined;
      this.selected4 = undefined;
      this.selected5 = undefined;
      this.selected7 = undefined;
      this.selected7a = undefined;
      this.selected7b = undefined;
      this.selected7c = undefined;
      this.selected7d = undefined;
      this.selected10 = undefined;
    }
    else if (value == 'spr-93') {
      this.scenarij1 = [
        {value: 'scenarij-0', viewValue: 'RCP2.6'},
        {value: 'scenarij-1', viewValue: 'RCP4.5'},
        {value: 'scenarij-2', viewValue: 'RCP8.5'}
      ];
      this.energSpr = [
        {value: 'energSpr-4', viewValue: 'Trajanje'},
        {value: 'energSpr-5', viewValue: 'Začetek'},
        {value: 'energSpr-6', viewValue: 'Konec'}
      ];
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled7 = true;
      this.selectDisabled7a = true;
      this.selectDisabled7b = true;
      this.selectDisabled7c = false;
      this.selectDisabled7d = true;
      this.selectDisabled8 = false;
      this.selectDisabled9 = true;
      this.selectDisabled10 = true;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden7 = false;
      this.hidden7a = false;
      this.hidden7b = false;
      this.hidden7c = true;
      this.hidden7d = false;
      this.hidden8 = true;
      this.hidden9 = false;
      this.hidden10 = false;
      this.selected3 = undefined;
      this.selected4 = undefined;
      this.selected5 = undefined;
      this.selected7 = undefined;
      this.selected7a = undefined;
      this.selected7b = undefined;
      this.selected7c = undefined;
      this.selected7d = undefined;
      this.selected9 = undefined;
      this.selected10 = undefined;
    }
    else if (value == 'spr-101') {
      this.scenarij1 = [
        {value: 'scenarij-0', viewValue: 'RCP2.6'},
        {value: 'scenarij-1', viewValue: 'RCP4.5'},
        {value: 'scenarij-2', viewValue: 'RCP8.5'}
      ];
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled7 = true;
      this.selectDisabled7a = true;
      this.selectDisabled7b = true;
      this.selectDisabled7c = true;
      this.selectDisabled7d = false;
      this.selectDisabled8 = false;
      this.selectDisabled9 = true;
      this.selectDisabled10 = true;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden7 = false;
      this.hidden7a = false;
      this.hidden7b = false;
      this.hidden7c = false;
      this.hidden7d = true;
      this.hidden8 = true;
      this.hidden9 = false;
      this.hidden10 = false;
      this.pretok = this.pretok;
      this.selected3 = undefined;
      this.selected4 = undefined;
      this.selected5 = undefined;
      this.selected7 = undefined;
      this.selected7a = undefined;
      this.selected7b = undefined;
      this.selected7c = undefined;
      this.selected7d = undefined;
      this.selected9 = undefined;
      this.selected10 = undefined;
    }

    else if (value == 'spr-31'|| value == 'spr-32' ){
      this.scenarij1 = [
        {value: 'scenarij-0', viewValue: 'RCP2.6'},
        {value: 'scenarij-1', viewValue: 'RCP4.5'},
        {value: 'scenarij-2', viewValue: 'RCP8.5'}
      ];
      this.sezona1 = [
        {value: 'sezona-0', viewValue: 'Leto'},
        {value: 'sezona-1', viewValue: 'Zima'},
        {value: 'sezona-2', viewValue: 'Pomlad'},
        {value: 'sezona-4', viewValue: 'Jesen'}
      ];
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled7 = true;
      this.selectDisabled7a = true;
      this.selectDisabled7b = true;
      this.selectDisabled7c = true;
      this.selectDisabled7d = true;
      this.selectDisabled8 = false;
      this.selectDisabled9 = false;
      this.selectDisabled10 = true;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden7 = false;
      this.hidden7a = false;
      this.hidden7b = false;
      this.hidden7c = false;
      this.hidden7d = false;
      this.hidden8 = true;
      this.hidden9 = true;
      this.hidden10 = false;
      this.selected3 = undefined;
      this.selected4 = undefined;
      this.selected5 = undefined;
      this.selected7 = undefined;
      this.selected7a = undefined;
      this.selected7b = undefined;
      this.selected7c = undefined;
      this.selected7d = undefined;
      this.selected10 = undefined;
    }


    else {
      this.scenarij1 = [
        {value: 'scenarij-0', viewValue: 'RCP2.6'},
        {value: 'scenarij-1', viewValue: 'RCP4.5'},
        {value: 'scenarij-2', viewValue: 'RCP8.5'}
      ];
      this.sezona1 = [
        {value: 'sezona-0', viewValue: 'Leto'},
        {value: 'sezona-1', viewValue: 'Zima'},
        {value: 'sezona-2', viewValue: 'Pomlad'},
        {value: 'sezona-3', viewValue: 'Poletje'},
        {value: 'sezona-4', viewValue: 'Jesen'}
      ];
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled7 = true;
      this.selectDisabled7a = true;
      this.selectDisabled7b = true;
      this.selectDisabled7c = true;
      this.selectDisabled7d = true;
      this.selectDisabled8 = false;
      this.selectDisabled9 = false;
      this.selectDisabled10 = true;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden7 = false;
      this.hidden7a = false;
      this.hidden7b = false;
      this.hidden7c = false;
      this.hidden7d = false;
      this.hidden8 = true;
      this.hidden9 = true;
      this.hidden10 = false;
      this.selected3 = undefined;
      this.selected4 = undefined;
      this.selected5 = undefined;
      this.selected7 = undefined;
      this.selected7a = undefined;
      this.selected7b = undefined;
      this.selected7c = undefined;
      this.selected7d = undefined;
      this.selected10 = undefined;
    }

    this.eventClicked2.emit(this.selected2);
    this.eventClicked3.emit(this.selected3);
    this.eventClicked4.emit(this.selected4);
    this.eventClicked5.emit(this.selected5);
    this.eventClicked7.emit(this.selected7);
    this.eventClicked7a.emit(this.selected7a);
    this.eventClicked7b.emit(this.selected7b);
    this.eventClicked7c.emit(this.selected7c);
    this.eventClicked7d.emit(this.selected7d);
    this.eventClicked8.emit(this.selected8);
    this.eventClicked9.emit(this.selected9);
    this.eventClicked10.emit(this.selected10);
  }

  thirdDropDownChanged(value: any) {
    console.log(value);
  }

  fourthDropDownChanged(value: any) {
    console.log(value);
    if (value == 'agro-1') {
      this.agroSprVse = [
        {value: 'tmpTal-0', viewValue: 'Povprečna temperatura tal na globini 5 cm (april-junij)'},
        {value: 'tmpTal-1', viewValue: 'Povprečna temperatura tal na globini 10 cm (april-junij)'},
        {value: 'tmpTal-2', viewValue: 'Povprečna temperatura tal na globini 20 cm (april-junij)'},
        {value: 'tmpTal-3', viewValue: 'Povprečna temperatura tal na globini 30 cm (april-junij)'},
        {value: 'tmpTal-4', viewValue: 'Povprečna temperatura tal na globini 5 cm (julij-september)'},
        {value: 'tmpTal-5', viewValue: 'Povprečna temperatura tal na globini 10 cm (julij-september)'},
        {value: 'tmpTal-6', viewValue: 'Povprečna temperatura tal na globini 20 cm (julij-september)'},
        {value: 'tmpTal-7', viewValue: 'Povprečna temperatura tal na globini 30 cm (julij-september)'}
      ];
      this.selectDisabled5 = false;
      this.selectDisabled7 = true;
      this.selectDisabled8 = true;
      this.selectDisabled9 = true;
      this.selectDisabled10 = true;
      this.hidden5 = true;
      this.hidden7 = false;
      this.hidden8 = false;
      this.hidden9 = false;
      this.hidden10 = false;
      this.selected5 = undefined;
      this.selected7 = undefined;
      this.selected8 = undefined;
      this.selected9 = undefined;
      this.selected10 = undefined;
      
    }
    else if (value == 'agro-2') {
      this.agroSprVse = [
        {value: 'feno-0', viewValue: 'Olistanje divjega kostanja'},
        {value: 'feno-1', viewValue: 'Olistanje bukve'},
        {value: 'feno-2', viewValue: 'Olistanje lipe'}
      ];
      this.selectDisabled5 = false;
      this.selectDisabled7 = true;
      this.selectDisabled8 = true;
      this.selectDisabled9 = true;
      this.selectDisabled10 = true;
      this.hidden5 = true;
      this.hidden7 = false;
      this.hidden8 = false;
      this.hidden9 = false;
      this.hidden10 = false;
      this.selected5 = undefined;
      this.selected7 = undefined;
      this.selected8 = undefined;
      this.selected9 = undefined;
      this.selected10 = undefined;

    }
    else if (value == 'agro-3') {
      this.agroSprVse = [
        {value: 'rastDoba-0', viewValue: 'Začetek rastne dobe za temperaturni prag 5 °C'},
        {value: 'rastDoba-1', viewValue: 'Začetek rastne dobe za temperaturni prag 10 °C'},
        {value: 'rastDoba-2', viewValue: 'Dolžina rastne dobe za temperaturni prag 5 °C'},
        {value: 'rastDoba-3', viewValue: 'Dolžina rastne dobe za temperaturni prag 10 °C'},
        {value: 'rastDoba-4', viewValue: 'Konec rastne dobe za temperaturni prag 5 °C'},
        {value: 'rastDoba-5', viewValue: 'Konec rastne dobe za temperaturni prag 10 °C'}
      ];
      this.selectDisabled5 = false;
      this.selectDisabled7 = true;
      this.selectDisabled8 = true;
      this.selectDisabled9 = true;
      this.selectDisabled10 = true;
      this.hidden5 = true;
      this.hidden7 = false;
      this.hidden8 = false;
      this.hidden9 = false;
      this.hidden10 = false;
      this.selected5 = undefined;
      this.selected7 = undefined;
      this.selected8 = undefined;
      this.selected9 = undefined;
      this.selected10 = undefined;

    }
    else {
      this.agroSprVse = [
        {value: 'pozeba-0', viewValue: 'Zadnja spomladanska pozeba (0 °C)'},
        {value: 'pozeba-1', viewValue: 'Zadnja spomladanska pozeba (-2 °C)'},
        {value: 'pozeba-2', viewValue: 'Prva jesenska pozeba (0 °C)'},
        {value: 'pozeba-3', viewValue: 'Prva jesenska pozeba (-2 °C)'},
        {value: 'pozeba-4', viewValue: 'Število dni s spomladansko pozebo (0 °C) za temperaturni prag 5 °C'},
        {value: 'pozeba-5', viewValue: 'Število dni s spomladansko pozebo (0 °C) za temperaturni prag 10 °C'},
        {value: 'pozeba-6', viewValue: 'Število dni s spomladansko pozebo (-2 °C) za temperaturni prag 5 °C'},
        {value: 'pozeba-7', viewValue: 'Število dni s spomladansko pozebo (-2 °C) za temperaturni prag 10 °C'},
        {value: 'pozeba-8', viewValue: 'Število dni z jesensko pozebo (0 °C) za temperaturni prag 5 °C'},
        {value: 'pozeba-9', viewValue: 'Število dni z jesensko pozebo (0 °C) za temperaturni prag 10 °C'},
        {value: 'pozeba-10', viewValue: 'Število dni z jesensko pozebo (-2 °C) za temperaturni prag 5 °C'},
        {value: 'pozeba-11', viewValue: 'Število dni z jesensko pozebo (-2 °C) za temperaturni prag 10 °C'},
        {value: 'pozeba-12', viewValue: 'Varnostna rezerva pred spomladansko pozebo (0 °C) za temperaturni prag 5 °C'},
        {value: 'pozeba-13', viewValue: 'Varnostna rezerva pred spomladansko pozebo (0 °C) za temperaturni prag 10 °C'},
        {value: 'pozeba-14', viewValue: 'Varnostna rezerva pred spomladansko pozebo (-2 °C) za temperaturni prag 5 °C'},
        {value: 'pozeba-15', viewValue: 'Varnostna rezerva pred spomladansko pozebo (-2 °C) za temperaturni prag 10 °C'},
        {value: 'pozeba-16', viewValue: 'Varnostna rezerva pred jesensko pozebo (0 °C) za temperaturni prag 5 °C'},
        {value: 'pozeba-17', viewValue: 'Varnostna rezerva pred jesensko pozebo (0 °C) za temperaturni prag 10 °C'},
        {value: 'pozeba-18', viewValue: 'Varnostna rezerva pred jesensko pozebo (-2 °C) za temperaturni prag 5 °C'},
        {value: 'pozeba-19', viewValue: 'Varnostna rezerva pred jesensko pozebo (-2 °C) za temperaturni prag 10 °C'}
      ];
      this.selectDisabled5 = false;
      this.selectDisabled7 = true;
      this.selectDisabled8 = true;
      this.selectDisabled9 = true;
      this.selectDisabled10 = true;
      this.hidden5 = true;
      this.hidden7 = false;
      this.hidden8 = false;
      this.hidden9 = false;
      this.hidden10 = false;
      this.selected5 = undefined;
      this.selected7 = undefined;
      this.selected8 = undefined;
      this.selected9 = undefined;
      this.selected10 = undefined;

    }
    this.eventClicked5.emit(this.selected5);
    this.eventClicked7.emit(this.selected7);
    this.eventClicked8.emit(this.selected8);
    this.eventClicked9.emit(this.selected9);
    this.eventClicked10.emit(this.selected10);

  } 

  fifthDropDownChanged(value: any) {
    console.log(value);

    if (value == 'tmpTal-0' || value == 'tmpTal-1' || value == 'tmpTal-2' || value == 'tmpTal-3' || value == 'tmpTal-4' || value == 'tmpTal-5' || value == 'tmpTal-6' || value == 'tmpTal-7' ) {
      this.postaje = [
        { value: 'post-0', viewValue: 'Bilje'},
        { value: 'post-1', viewValue: 'Celje'},
        { value: 'post-2', viewValue: 'Ljubljana'},
        { value: 'post-3', viewValue: 'Novo mesto'},
        { value: 'post-4', viewValue: 'Maribor'},
        { value: 'post-5', viewValue: 'Murska Sobota'},
        { value: 'post-6', viewValue: 'Šmartno pri Slovenj Gradcu'} 
      ];
      this.selectDisabled10 = false;
      this.hidden10 = true;
    }

    else if (value == 'feno-1') {
      this.postaje = [
        { value: 'post-1', viewValue: 'Celje'},
        { value: 'post-2', viewValue: 'Lesce'},
        { value: 'post-3', viewValue: 'Ljubljana'},
        { value: 'post-4', viewValue: 'Novo mesto'},
        { value: 'post-6', viewValue: 'Slovenske Konjice'},
        { value: 'post-7', viewValue: 'Starše'},
        { value: 'post-8', viewValue: 'Veliki Dolenci'}
      ];
      this.selectDisabled10 = false;
      this.hidden10 = true;
      this.selected10 = undefined;
    }
    else if (value == 'feno-2') {
      this.postaje = [
        { value: 'post-1', viewValue: 'Celje'},
        { value: 'post-2', viewValue: 'Lesce'},
        { value: 'post-3', viewValue: 'Ljubljana'},
        { value: 'post-4', viewValue: 'Novo mesto'},
        { value: 'post-6', viewValue: 'Slovenske Konjice'},
        { value: 'post-7', viewValue: 'Starše'}
      ];
      this.selectDisabled10 = false;
      this.hidden10 = true;
      this.selected10 = undefined;
    }
    else {
      this.postaje = [
        { value: 'post-0', viewValue: 'Bilje'},
        { value: 'post-1', viewValue: 'Celje'},
        { value: 'post-2', viewValue: 'Lesce'},
        { value: 'post-3', viewValue: 'Ljubljana'},
        { value: 'post-4', viewValue: 'Novo mesto'},
        { value: 'post-5', viewValue: 'Portorož'},
        { value: 'post-6', viewValue: 'Slovenske Konjice'},
        { value: 'post-7', viewValue: 'Starše'},
        { value: 'post-8', viewValue: 'Veliki Dolenci'}
      ];
      this.selectDisabled10 = false;
      this.hidden10 = true;
    }

    this.eventClicked5.emit(this.selected5);
    this.eventClicked7.emit(this.selected7);
    this.eventClicked8.emit(this.selected8);
    this.eventClicked9.emit(this.selected9);
    this.eventClicked10.emit(this.selected10);
  } 


  seventhDropDownChanged(value: any) {
    console.log(value);

    if (value == 'padKaz-8' || value == 'padKaz-9') {
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled7 = false;
      this.selectDisabled8 = false;
      this.selectDisabled9 = false;
      this.selectDisabled10 = false;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden7 = true;
      this.hidden8 = true;
      this.hidden9 = true;
      this.hidden10 = true;
      this.padKazalniki = this.padKazalniki;
      this.selected3 = undefined;
      this.selected4 = undefined;
    }

    else {
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled7 = false;
      this.selectDisabled8 = false;
      this.selectDisabled9 = true;
      this.selectDisabled10 = true;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden7 = true;
      this.hidden8 = true;
      this.hidden9 = false;
      this.hidden10 = false;
      this.padKazalniki = this.padKazalniki;
      this.selected3 = undefined;
      this.selected4 = undefined;
      this.selected9 = undefined;
      this.selected10 = undefined;
    }

    this.eventClicked7.emit(this.selected7);
    this.eventClicked7a.emit(this.selected7a);
    this.eventClicked7b.emit(this.selected7b);
    this.eventClicked7c.emit(this.selected7c);
    this.eventClicked7d.emit(this.selected7d);
    this.eventClicked8.emit(this.selected8);
    this.eventClicked9.emit(this.selected9);
    this.eventClicked10.emit(this.selected10);

  } 

  seventhaDropDownChanged(value: any) {
    console.log(value);

    if (value == 'spi-0' || value == 'spi-2' || value == 'spi-6') {
      this.scenarij1 = [
        {value: 'scenarij-0', viewValue: 'RCP2.6'},
        {value: 'scenarij-1', viewValue: 'RCP4.5'},
        {value: 'scenarij-2', viewValue: 'RCP8.5'}
      ];
      this.sezona1 = [
        {value: 'sezona-5', viewValue: 'Rastna doba'},
        {value: 'sezona-6', viewValue: 'April-Junij'},
        {value: 'sezona-7', viewValue: 'Julij-September'},
        {value: 'sezona-8', viewValue: 'April'},
        {value: 'sezona-9', viewValue: 'Maj'},
        {value: 'sezona-10', viewValue: 'Junij'},
        {value: 'sezona-11', viewValue: 'Julij'},
        {value: 'sezona-12', viewValue: 'Avgust'},
        {value: 'sezona-13', viewValue: 'September'}
      ];
      this.selectDisabled8 = false;
      this.selectDisabled9 = false;
      this.selectDisabled10 = true;
      this.hidden8 = true;
      this.hidden9 = true;
      this.hidden10 = false;
      this.selected10 = undefined;
    }

    else {
      this.scenarij1 = [
        {value: 'scenarij-0', viewValue: 'RCP2.6'},
        {value: 'scenarij-1', viewValue: 'RCP4.5'},
        {value: 'scenarij-2', viewValue: 'RCP8.5'}
      ];
      this.selectDisabled8 = false;
      this.selectDisabled9 = true;
      this.selectDisabled10 = true;
      this.hidden8 = true;
      this.hidden9 = false;
      this.hidden10 = false;
      this.selected9 = undefined;
      this.selected10 = undefined;
    }

    this.eventClicked7.emit(this.selected7);
    this.eventClicked7a.emit(this.selected7a);
    this.eventClicked7b.emit(this.selected7b);
    this.eventClicked7c.emit(this.selected7c);
    this.eventClicked7d.emit(this.selected7d);
    this.eventClicked8.emit(this.selected8);
    this.eventClicked9.emit(this.selected9);
    this.eventClicked10.emit(this.selected10);

  }

  seventhbDropDownChanged(value: any) {
    console.log(value);

    if (value == 'spei-0' || value == 'spei-4' || value == 'spei-8') {
      this.scenarij1 = [
        {value: 'scenarij-1', viewValue: 'RCP4.5'},
        {value: 'scenarij-2', viewValue: 'RCP8.5'}
      ];
      this.sezona1 = [
        {value: 'sezona-5', viewValue: 'Rastna doba'},
        {value: 'sezona-6', viewValue: 'April-Junij'},
        {value: 'sezona-7', viewValue: 'Julij-September'},
        {value: 'sezona-8', viewValue: 'April'},
        {value: 'sezona-9', viewValue: 'Maj'},
        {value: 'sezona-10', viewValue: 'Junij'},
        {value: 'sezona-11', viewValue: 'Julij'},
        {value: 'sezona-12', viewValue: 'Avgust'},
        {value: 'sezona-13', viewValue: 'September'}
      ];
      this.selectDisabled8 = false;
      this.selectDisabled9 = false;
      this.selectDisabled10 = true;
      this.hidden8 = true;
      this.hidden9 = true;
      this.hidden10 = false;
      this.selected10 = undefined;
    }

    else {
      this.scenarij1 = [
        {value: 'scenarij-1', viewValue: 'RCP4.5'},
        {value: 'scenarij-2', viewValue: 'RCP8.5'}
      ];
      this.selectDisabled8 = false;
      this.selectDisabled9 = true;
      this.selectDisabled10 = true;
      this.hidden8 = true;
      this.hidden9 = false;
      this.hidden10 = false;
      this.selected9 = undefined;
      this.selected10 = undefined;
    }

    this.eventClicked7.emit(this.selected7);
    this.eventClicked7a.emit(this.selected7a);
    this.eventClicked7b.emit(this.selected7b);
    this.eventClicked7c.emit(this.selected7c);
    this.eventClicked7d.emit(this.selected7d);
    this.eventClicked8.emit(this.selected8);
    this.eventClicked9.emit(this.selected9);
    this.eventClicked10.emit(this.selected10);

  }

  seventhcDropDownChanged(value: any) {
    console.log(value);
  }

  seventhdDropDownChanged(value: any) {
    console.log(value);
  }

  eigthDropDownChanged(value: any) {
    console.log(value);
  }

  ninthDropDownChanged(value: any) {
    console.log(value);
  }

  tenthDropDownChanged(value: any) {
    console.log(value);

  }



  @Output() eventClicked1 = new EventEmitter<Event>();
  @Output() eventClicked2 = new EventEmitter<Event>();
  @Output() eventClicked3 = new EventEmitter<Event>();
  @Output() eventClicked4 = new EventEmitter<Event>();
  @Output() eventClicked5 = new EventEmitter<Event>();
  @Output() eventClicked7 = new EventEmitter<Event>();
  @Output() eventClicked7a = new EventEmitter<Event>();
  @Output() eventClicked7b = new EventEmitter<Event>();
  @Output() eventClicked7c = new EventEmitter<Event>();
  @Output() eventClicked7d = new EventEmitter<Event>();
  @Output() eventClicked8 = new EventEmitter<Event>();
  @Output() eventClicked9 = new EventEmitter<Event>();
  @Output() eventClicked10 = new EventEmitter<Event>();

  constructor(private router: Router,
    private route: ActivatedRoute) { }

  ngOnInit() {
  }

  onClick1(selected1: Event): void {
    this.eventClicked1.emit(selected1);
  }

  onClick2(selected2: Event): void {
    this.eventClicked2.emit(selected2);
  }

  onClick3(selected3: Event): void {
    this.eventClicked3.emit(selected3);
  }

  onClick4(selected4: Event): void {
    this.eventClicked4.emit(selected4);
  }

  onClick5(selected5: Event): void {
    this.eventClicked5.emit(selected5);
  }

  onClick7(selected7: Event): void {
    this.eventClicked7.emit(selected7);
  }

  onClick7a(selected7a: Event): void {
    this.eventClicked7a.emit(selected7a);
  }

  onClick7b(selected7b: Event): void {
    this.eventClicked7b.emit(selected7b);
  }

  onClick7c(selected7c: Event): void {
    this.eventClicked7c.emit(selected7c);
  }

  onClick7d(selected7d: Event): void {
    this.eventClicked7d.emit(selected7d);
  }

  onClick8(selected8: Event): void {
    this.eventClicked8.emit(selected8);
  }

  onClick9(selected9: Event): void {
    this.eventClicked9.emit(selected9);
  }

  onClick10(selected10: Event): void {
    this.eventClicked10.emit(selected10);
  }
}
